import type {
	ProductNode,
	StraightenerProduct,
	StraightenerRecipeVersion,
} from "../straightener-recipes/models/StraightenerRecipe";

// Builds one node per mill product with all of its recipe versions, sorted:
// current first, then by last modified (falls back to created) descending.
// Shared by the Recipes manager tree and the Trend Display inline editor.
export const buildProductNodes = (
	products: StraightenerProduct[],
	recipes: StraightenerRecipeVersion[],
): ProductNode[] => {
	const versionsByProduct = new Map<number, StraightenerRecipeVersion[]>();
	for (const r of recipes) {
		const list = versionsByProduct.get(r.ProductSizeId) ?? [];
		list.push(r);
		versionsByProduct.set(r.ProductSizeId, list);
	}
	return products.map((p) => {
		const versions = (versionsByProduct.get(p.Id) ?? [])
			.slice()
			.sort((a, b) => {
				if (a.IsCurrent !== b.IsCurrent) return a.IsCurrent ? -1 : 1;
				// CreatedAt already carries COALESCE(LastModifiedAt, CreatedAt).
				return (b.CreatedAt ?? "").localeCompare(a.CreatedAt ?? "");
			});
		return {
			productSizeId: p.Id,
			productName: p.Name,
			productTypeName: p.ProductTypeName,
			versions,
			current: versions.find((v) => v.IsCurrent) ?? null,
		};
	});
};
